import { Auth } from "src/models/Auth"; 
import { api } from "../config/AxiosConfig";
import { API_ROOT } from "./ApiUrlFormatter";

const clientId: string = "com.emlpayments.reporthub";

export const AuthApi = {
  login: async (username: string, password: string) => {
    const response = await api.post<Auth>(
        `${API_ROOT}/authorization/token`,
        `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&client_id=${clientId}&grant_type=password`,
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            }            
        }
    )
    return response.data
  }  
}
